export { default as UserCard } from "./UserCard";



// WEBPACK FOOTER //
// ./src/modules/manager/components/index.js